import { Card, CardBody, Col, Button, InputGroup, InputGroupText } from "reactstrap";
import { FaEdit, FaSave } from "react-icons/fa";
import { NumericFormat } from "react-number-format";

export const LogisticsCountry = ({
  selectedCountry,
  countryShippingValue,
  setCountryShippingValue,
  editMode,
  setEditMode,
  handleSaveShippingCost,
  isPending,
  cityCount = 0
}) => {
  return (
    <>
      <Col md="3">
        <Card className="mb-3 shadow-sm border-0 h-100">
          <CardBody className="d-flex flex-column justify-content-center text-center py-4">
            <h6 className="text-muted mb-1">País seleccionado</h6>
            <h5 className="fw-bold mb-0">{selectedCountry.name}</h5>
          </CardBody>
        </Card>
      </Col>

      <Col md="3">
        <Card className="mb-3 shadow-sm border-0 h-100 text-center">
          <CardBody className="d-flex flex-column justify-content-center py-4">
            <h6 className="text-muted mb-1">Ciudades registradas con costo de envío	</h6>
            <h5 className="fw-bold mb-0">
              {cityCount}
            </h5>
          </CardBody>
        </Card>
      </Col>

      <Col md="6">
        <Card className="mb-3 shadow-sm border-0 h-100">
          <CardBody className="py-4">
            <h6 className="text-muted mb-2">Costo de envío pais</h6>
            <div className="d-flex flex-column flex-md-row align-items-md-center gap-3">
              <div style={{ flex: "0 0 70%" }}>
                <InputGroup className="w-100">
                  <NumericFormat
                    className="form-control"
                    thousandSeparator="."
                    decimalSeparator=","
                    decimalScale={2}
                    fixedDecimalScale
                    allowNegative={false}
                    value={countryShippingValue}
                    disabled={!editMode}
                    onValueChange={(values) => setCountryShippingValue(values.value)}
                    placeholder="Ej: 5.000"
                  />
                  <InputGroupText>{selectedCountry.currency || "$"}</InputGroupText>
                </InputGroup>
              </div>

              <div style={{ flex: "0 0 30%" }}>
                {editMode ? (
                  <Button
                    color="success"
                    disabled={isPending}
                    onClick={handleSaveShippingCost}
                    className="w-100 d-flex align-items-center justify-content-center gap-2"
                  >
                    <FaSave /> {isPending ? "Guardando..." : "Guardar"}
                  </Button>
                ) : (
                  <Button
                    color="primary"
                    outline
                    onClick={() => setEditMode(true)}
                    className="w-100 d-flex align-items-center justify-content-center gap-2"
                  >
                    <FaEdit /> Editar
                  </Button>
                )}
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>


    </>
  );
};
